<template>
    <v-card v-if="company && email">
        <!-- Header -->
        <v-layout wrap row v-if="company.logo_url">
            <v-flex xs12 class="py-3 bg-light">
                <v-img
                height="5vmin"
                contain
                :src="company.logo_url"
                ></v-img>
            </v-flex>
        </v-layout>
        <!-- Content -->
        <v-layout wrap row>
            <v-flex xs12 class="pa-4">
                <div v-html="email.mail_body" :dir="(company.custom_properties && company.custom_properties.is_rtl)?'RTL':'LTR'"></div>
            </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <!-- Footer -->
        <v-layout wrap row>
            <v-flex xs12 class="py-3 bg-light">
                <div class="text-xs-center mail-preview-footer">
                    <div>Powered By Movies Everywhere</div>
                    <div>© <span>{{ moment().year() }}</span> <span v-if="company">{{ company.title}}</span> . All rights reserved.</div>
                </div>
            </v-flex>
        </v-layout>
    </v-card>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
    name: "CustomizeEmailPreview",
    props: {
        email: {
            type: Object,
            default: null,
        }
    },
    computed: {
        ...mapGetters({
            company: "company/getSelectedCompany",
        }),
    },
}
</script>

<style scoped>
.bg-light{
    background-color: #f8fafc;
}
.mail-preview-footer{
    color: #aeaeae;
    font-size: 12px;
}
</style>